module.exports = __webpack_public_path__ + "img/2.b41a688a.jpg";